<template>
  <loader v-bind="{ loading }">
    <page-navigation :title="`Environments (${environments.total})`">
      <template #right>
        <search-bar
          v-model="filters.search"
          @run-search="search"
          @clear-search="clearSearch">
          <template #buttons>
            <router-link
              :to="{ name: 'create-environment' }"
              class="is-rounded button">
              <icon icon="plus"/>
              <span>Environment</span>
            </router-link>
          </template>
        </search-bar>
      </template>
    </page-navigation>  

    <columns>
      <column>
        <index-row
          v-for="environment in environments.data" :key="environment.id"
          has-avatar
          :avatar="{ path: environment.logo_url, name: environment.name }"
          :title="environment.name"
          :route="{ name: 'environment-manager', params: { environment: environment.id }}">
            <span class="has-text-weight-light">{{ environment.app.name }}</span>
            <span class="help">last active {{ environment.updated_at | asCalendar }}</span>
            <template #right>
              <flex class="mr-5">
                <problem-count :count="environment.app.environments_count" />
              </flex>
              <flex class="mr-5 ml-5">
                <local-env-count :count="environment.app.environments_count" />
              </flex>
            </template>
        </index-row>  

        <pager v-if="environments.next_page_url || environments.prev_page_url" context="environment" :pageable="environments" @nav="goTo"/>
        
        <no-items-to-show v-if="!environments.data.length && !environments.total" text="No Environments Found">
          <router-link
            :to="{ name: 'create-environment' }"
            class="is-rounded button">
            <icon icon="plus"/>
            <span>Create an Environment</span>
          </router-link>
        </no-items-to-show>  

      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Environments',

  data: () => ({
    environments: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Enviroments')
  },

  created() {
    if (this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadEnvironments()
  },

  methods: {
    loadEnvironments() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({ data }) => {
        this.environments = data
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    search() {
      if (!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'environments',
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'environments',
        query: {}
      })
    }
  },

  watch: {
    '$route': 'loadEnvironments'
  }
}
</script>
